<div class="custom-backdrop"></div>

<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title pull-left">NPS - Nos ajude a melhorar a plataforma!</h4>
      <button
        type="button"
        (click)="fecharModal()"
        class="btn-close"
        aria-label="Close"
      >
        X
      </button>
    </div>

    <div class="modal-body">
      <div class="bloco-principal">
        <img
          class="img-fluid"
          src="{{
            BASE_IMG_URL
          }}assets/header/alert-nova-feature.png"
          alt="Imagem"
          width="124"
          height="136"
        />
        <!-- <p class="texto titulo m-0">
         {{description}}
        </p> -->
      </div>

      <div class="box-ranking">
        <div class="sec-avaliar">
          <p>Em uma escala de 0 a 10, o quanto você recomendaria a Rede de Obras para outras empresas do setor?</p>

          <div class="avaliacao-circular">
            <ul class="list-inline">
              <li
                *ngFor="let nota of notas"
                [ngClass]="[
                  'nota-' + nota,
                  selectedValue === nota ? 'selected' : ''
                ]"
                (click)="selectNota(nota)"
              >
                {{ nota }}
              </li>
            </ul>
          </div>
        </div>

        <div class="mt-3 sec-sugestao">
          <p>
            Tem alguma sugestão de melhoria para o Rede de Obras? Compartilhe
            conosco!
          </p>

          <textarea
            name="sugestao"
            id="sugestao"
            cols="30"
            rows="2"
            maxlength="2048"
            [(ngModel)]="opiniao"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="botao-ok"
        (click)="sendOpiniao()"
        [disabled]="selectedValue === 0"
      >
        ENVIAR
      </button>
    </div>
  </div>
</div>

<!-- @if (exibirModal) {
<div class="custom-backdrop"></div>

<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Pesquisa de satisfação</h4>
      <button type="button" class="btn-close" aria-label="Close">X</button>
    </div>

    <div class="modal-body">
      <div class="bloco-principal">
        <img
          class="me-5"
          src="{{
            BASE_IMG_URL
          }}assets/header/alert-nova-feature.png"
          alt="Imagem"
          width="124"
          height="136"
        />
        <p class="texto titulo m-0">
          Em uma escala de 0 a 10, o quanto você recomendaria o Rede de Obras
          para outras empresas do setor?
        </p>
      </div>

      <div class="box-ranking">
        <div class="sec-avaliar">
          <p>"Qual seu nível geral de satisfação com o novo menu ?</p>

          <div class="avaliacao-circular">
            <ul class="list-inline">
              <li
                *ngFor="let nota of notas"
                [ngClass]="[
                  'nota-' + nota,
                  selectedValue === nota ? 'selected' : ''
                ]"
                (click)="selectNota(nota)"
              >
                {{ nota }}
              </li>
            </ul>
          </div>
        </div>

        <div class="mt-3 sec-sugestao">
          <p>
            Tem alguma sugestão de melhoria para o Rede de Obras? Compartilhe
            conosco!
          </p>

          <textarea
            name="sugestao"
            id="sugestao"
            cols="30"
            rows="2"
            maxlength="2048"
            [(ngModel)]="opiniao"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="botao-ok"
        (click)="sendOpiniao()"
        [disabled]="selectedValue === 0"
      >
        ENVIAR
      </button>
    </div>
  </div>
</div>
} -->
